// extracted by mini-css-extract-plugin
module.exports = {"container":"carouselImage_container__2WJ-I"};